(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tablet', {
            parent: 'entity',
            url: '/tablet',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.tablet.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tablet/tablets.html',
                    controller: 'TabletController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tablet');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tablet-detail', {
            parent: 'entity',
            url: '/tablet/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.tablet.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tablet/tablet-detail.html',
                    controller: 'TabletDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tablet');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Tablet', function($stateParams, Tablet) {
                    return Tablet.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tablet',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('tablet-detail.edit', {
            parent: 'tablet-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tablet/tablet-dialog.html',
                    controller: 'TabletDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Tablet', function(Tablet) {
                            return Tablet.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tablet.new', {
            parent: 'tablet',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tablet/tablet-dialog.html',
                    controller: 'TabletDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                tablet: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tablet', null, { reload: 'tablet' });
                }, function() {
                    $state.go('tablet');
                });
            }]
        })
        .state('tablet.edit', {
            parent: 'tablet',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tablet/tablet-dialog.html',
                    controller: 'TabletDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Tablet', function(Tablet) {
                            return Tablet.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tablet', null, { reload: 'tablet' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tablet.delete', {
            parent: 'tablet',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tablet/tablet-delete-dialog.html',
                    controller: 'TabletDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Tablet', function(Tablet) {
                            return Tablet.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tablet', null, { reload: 'tablet' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
